import React from 'react';

export default ({ children, title }) => (
    <div className="gallery-photo-video-embed">
        <div className="gallery-bg-dark">
            <div className="px-x2-custom">
                <h3>{title}</h3>
                <div className="it-carousel-wrapper">
                    <div className="it-carousel-all it-img-card">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    </div>
);
